import * as AT from '../constants/actionTypes'

/**
 * Target reducer
 * @param {*} state 
 * @param {*} action 
 */
function target(state = { actualTarget: {}, targets: [] }, action) {
	switch (action.type) {
		case AT.PROFILE_LOGOUT:
			return Object.assign({}, state, {
				actualTarget: [],
				targets: [],
			})
		case AT.TARGET_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				actualTarget: [],
				error: undefined
			})
    	case AT.TARGET_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
    	case AT.TARGET_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				actualTarget: action.payload.actualTarget,
				error: undefined
			})
		case AT.TARGET_LIST_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				targets: [],
				error: undefined
			})
		case AT.TARGET_LIST_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.TARGET_LIST_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				targets: action.payload.targets,
				error: undefined
			})
		case AT.TARGET_UI_CLEAR:
			return Object.assign({}, state, {
				error: undefined
			})
		case AT.TARGET_SEARCH_CLEAR:
			return Object.assign({}, state, {
				targets: [],
				error: undefined
			})
		default:
			return state;
	}
}

export default target;